// src/pages/Contact.jsx
import { useContactViewModel } from '../viewmodels/useContactViewModel';
import { Send, CheckCircle } from 'lucide-react';

export default function Contact() {
  const { form, status, handleChange, handleSubmit } = useContactViewModel();

  return (
    <section className="section" id="contact">
      <div className="container text-center">
        <p className="section-subtitle">How can you communicate?</p>
        <h6 className="section-title mb-5">Contact Me</h6>

        {/* Meyawo Contact Form */}
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
            <div>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
                className="form-control"
              />
            </div>
            <div>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter Email"
                required
                className="form-control"
              />
            </div>
          </div>

          <div className="mb-4">
            <input
              type="text"
              name="subject"
              value={form.subject}
              onChange={handleChange}
              placeholder="Subject / Project Inquiry"
              required
              className="form-control"
            />
          </div>

          <div className="mb-5">
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              placeholder="Write Something..."
              rows={6}
              required
              className="form-control"
            ></textarea>
          </div>

          <div>
            <button
              type="submit"
              disabled={status === 'loading' || status === 'success'}
              className="btn btn-outline-primary rounded px-8 py-3 w-full sm:w-auto"
            >
              {status === 'loading' && (
                <span className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin mr-2" />
              )}
              {status === 'success' && <CheckCircle size={16} className="mr-2" />}
              {status === 'loading' && 'Sending...'}
              {status === 'success' && 'Message Sent!'}
              {status === 'idle' && (
                <>
                  <Send size={15} className="mr-2 inline" /> Send Message
                </>
              )}
              {status === 'error' && 'Failed to Send. Try Again'}
            </button>
          </div>

          {status === 'success' && (
            <p className="text-green-600 font-semibold mt-4 text-sm">
              Thank you! Your message has been sent successfully. I will get back to you shortly.
            </p>
          )}
          {status === 'error' && (
            <p className="text-red-500 font-semibold mt-4 text-sm">
              Oops! Something went wrong. Please email directly at ismailjabiulla06@gmail.com
            </p>
          )}
        </form>
      </div>
    </section>
  );
}
